import {
  transition_default
} from "./chunk-SIH73G3H.mjs";
import {
  z_index_default
} from "./chunk-45VJLTIL.mjs";
import {
  borders_default
} from "./chunk-B75T2J64.mjs";
import {
  breakpoints_default
} from "./chunk-TXLFBUTF.mjs";
import {
  colors_default
} from "./chunk-E47HH2QS.mjs";
import {
  radius_default
} from "./chunk-VIVTPWHP.mjs";
import {
  shadows_default
} from "./chunk-IZUFFCXS.mjs";
import {
  blur_default
} from "./chunk-HQ6WXDYV.mjs";
import {
  typography_default
} from "./chunk-6XA2KDUD.mjs";
import {
  sizes_default
} from "./chunk-NJCYBKFH.mjs";
import {
  spacing
} from "./chunk-V7WMN6TQ.mjs";

// src/foundations/index.ts
var foundations = {
  breakpoints: breakpoints_default,
  zIndices: z_index_default,
  radii: radius_default,
  blur: blur_default,
  colors: colors_default,
  ...typography_default,
  sizes: sizes_default,
  shadows: shadows_default,
  space: spacing,
  borders: borders_default,
  transition: transition_default
};

export {
  foundations
};
//# sourceMappingURL=chunk-3WO5B3NB.mjs.map